<template>
  <div class="rights-list" v-loading="loading">
    <div class="list">
      <div class="title-box">
        <span class="label"
          >平台会不定期会推出各类招聘权益给大家免费领取使用，以答谢招聘官们的支持和喜爱！</span
        >
      </div>
      <div class="select">
        <el-form
          :inline="true"
          :model="formData"
          ref="form"
          class="form-inline"
          size="mini"
        >
          <el-form-item label="状态">
            <el-select
              v-model="formData.state"
              @change="
                (value) => {
                  handleChange('state', value);
                }
              "
            >
              <el-option label="全部" :value="null"></el-option>
              <el-option label="可领取" :value="1"></el-option>
              <el-option label="已领取" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区">
            <el-select
              v-model="formData.city"
              @change="
                (value) => {
                  handleChange('city', value);
                }
              "
            >
            <el-option
              v-for="item in city_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="items">
        <div
          class="item"
          :class="item.had_receive === 1 ? 'active' : ''"
          v-for="(item, index) in result"
          :key="index"
        >
          <div class="title">
            <div class="text">
              {{
                item.product_type === 2
                  ? "职位发布数"
                  : item.product_type === 3
                  ? "职位置顶点"
                  : item.product_type === 4
                  ? "简历下载点"
                  : item.product_type === 5
                  ? "职位刷新点"
                  : "职位省心推"
              }}
              <span>*{{ item.use_num }}</span>
            </div>
            <div class="btn" @click="handleFree(item)">
              {{ item.had_receive === 0 ? "免费领" : "已领取" }}
            </div>
          </div>
          <div class="region">领取对象：{{ item.receive_obj===1?'所有人':'招聘PLUS会员' }}</div>
          <!-- <div class="region">使用地区：{{ item.province || '全国' }}</div> -->
          <div class="date">
            有效时间：{{
              dateFormat("YYYY.mm.dd", item.effect_start_time, "string")
            }}-{{ dateFormat("YYYY.mm.dd", item.effect_end_time, "string") }}
          </div>
        </div>
      </div>
      <el-pagination
        v-if="!noData"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[resultPage.per_page]"
        :page-size="resultPage.per_page"
        layout="total, sizes, prev, pager, next, jumper"
        :total="resultPage.total"
      >
      </el-pagination>
      <div class="no-box" v-else>
        <NoData :title="title" style="margin: 10px 0"></NoData>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from "$global/NoData";
import { dateFormat } from "@/utils/index";
import { mapState } from "vuex";

export default {
  name: "RightsList",
  components: {
    NoData,
  },
  data() {
    return {
      title: `暂时没有对应的权益领取~</br>敬请留意地产同行圈微信群内的通知`,
      currentPage: 1,
      result: [],
      resultPage: {
        per_page: 1,
        total: 0,
      },
      noData: false,
      loading: false,
      formData: {
        state: null,
        province: null,
        city: null
      },
      city_options: [],
      dateFormat,
      freeLoading: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.$axios.post('/recruitment/config/province_city',{
      type:2
    }).then((res) => { 
      this.city_options=res.data.items.map(item=>({'label':item.province,'value':item.province}));
      this.city_options.unshift({
        value: null,
        label: "全部",
      },{
        value: '',
        label: "全国",
      });   
    });
  },
  mounted() {
    this.init();
  },
  methods: {
    loadData() {
      this.$axios
        .post("/recruitment/employ_activity/free_right", {
          state: this.formData.state || undefined,
          province:this.formData.city || undefined,
          per_page: 9,
          page_flag: 1,
          total_flag: 1,
          current_page: this.currentPage,
        })
        .then((res) => {
          this.result = [];

          if (res.data.items.length == 0) {
            this.noData = true;
            this.loading = false;
          } else {
            this.noData = false;
            this.loading = false;
            this.result = res.data.items;
            this.resultPage = res.data.paging;
          }
        });
    },
    init() {
      this.loading = true;
      this.loadData();
    },
    handleSizeChange() {
      this.loading = true;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.loading = true;
      this.currentPage = val;
      this.loadData();
    },
    handleChange(type, val) {
      this.loading = true;
      this.loadData();
    },
    handleFree(item) {
      if (this.freeLoading) {
        return;
      }
     
      if (item.had_receive === 1) {
        this.$fail("企业已经领取过该权益啦~");
        return;
      }
      if(this.userInfo.company.member_level === 1 && item.receive_obj === 2){
          this.$confirm(
            "该权益限平台招聘PLUS会员免费领取，如需开通可联系服务顾问购买招聘套餐",
            "",
            {
              confirmButtonText: "联系顾问",
              cancelButtonText: "取消",
              type: "",
            }
          ).then(() => {
            this.$bus.$emit("openCustomer");
          });
        return;
      }
      // const date = new Date().getTime();
      // const start_time = new Date(item.effect_start_time).getTime();
      // const end_time = new Date(item.effect_end_time).getTime();

      // if (date < start_time || date > end_time) {
      //   this.$fail("该权益已暂停领取");
      //   return;
      // }

      this.freeLoading = true;
      this.$axios
        .post("/recruitment/employ_activity/receive_product", {
          id: item.id,
        })
        .then(() => {
          this.loadData();
          this.$bus.$emit("updateFreeRight");
          this.$alert(
            "权益领取成功，可在“招聘权益-权益获得记录”中查看",
            "领取成功",
            {
              confirmButtonText: "好的",
              showClose: true,
              callback: () => {
                this.freeLoading = false;
              },
            }
          );
        })
        .catch((err) => {
          if(err.data.code === "Error5201006"){
            this.$alert(
              `${err.data.msg}`,
              "",
              {
                confirmButtonText: "好的",
                center: true,
              }
            );
          }
          this.freeLoading = false;
        });
    },
  },
};
</script>

<style lang='scss'>
@import "./index.scss";
</style>
